// core version + navigation, pagination modules:
import Swiper, { Pagination, FreeMode } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

// import our own default styles. these can be overidden when required.
import '../../styles/components/carousel.css';

const defaultOptions = {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  spaceBetween: 20,
  slidesOffsetBefore: 20,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      slidesOffsetBefore: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 32,
      slidesOffsetBefore: 64,
    },
  },
};

/**
 *
 * @param {Node} el The carousel wrapper element
 * @param {*} [options] The options object
 * @param {'horizontal' | 'vertical'} [options.direction=horizontal] The carousel direction
 * @param {boolean} [options.loop=true] To loop to start or not.
 * @param {number} [options.slidesPerView=1] Number of slides in view
 * @param {boolean} [options.centeredSlides=true] Center the slides or not
 * @param {any} [options.any] Pass any additional options
 * @param {boolean} [cornerNav] To give the swiper arrows styling in the upper right
 * @returns {null | swiper} Null or the initialized carousel
 *
 */
export default function carousel(el, options = {}) {
  if (!el) return null;

  const opts = { ...defaultOptions, ...options };
  const swiper = new Swiper(el, {
    ...opts,
    modules: [Pagination, FreeMode],
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    freeMode: true,
  });
  return swiper;
}
